/**
 * Permissions Form - Manejo de formularios de creación y edición de permisos
 */
export class PermissionsForm {
    constructor() {
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeForm();
            });
        }
        else {
            this.initializeForm();
        }
    }
    initializeForm() {
        const permissionForm = document.getElementById('permissionForm');
        if (!permissionForm) {
            return;
        }
    }
}
export default PermissionsForm;
